/* ============================================================
   Fertia — Mobile-Verbesserungen (Theme v4)
   1. Auto-Scroll für alle horizontalen Karussells (+ Punkte)
   2. Auto-Scroll für das Judge.me-Bewertungs-Karussell
   3. Logo-Laufband für die Fachgesellschaften (mobil)
   4. Mobile Sticky-Kaufleiste auf Produktseiten
   5. Mobile-Menue: Drawer folgt dem Viewport + "Übersicht"-Link
   Alles pausiert, sobald der Nutzer selbst wischt/tippt.
   ============================================================ */
(function () {
  'use strict';

  var mqMobile = window.matchMedia('(max-width: 749px)');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------- 1. Horizontale Karussells ---------------- */

  var SCROLLERS = '.fh-row, .fh-grid, .slider--mobile, .product__media-list, [class*="ai-steps-grid-"]';
  var tracked = [];

  function isScrollable(el) {
    var ox = getComputedStyle(el).overflowX;
    return (ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth + 8;
  }

  function slidesOf(el) {
    return Array.prototype.filter.call(el.children, function (c) {
      return c.offsetWidth > 0 && c.offsetHeight > 0;
    });
  }

  // Position eines Kindes relativ zum Scroll-Anfang des Containers
  function pos(el, child) {
    return child.getBoundingClientRect().left - el.getBoundingClientRect().left + el.scrollLeft;
  }

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.top < h - 60 && r.bottom > 60;
  }

  // Eigene Animation statt scrollTo({behavior:'smooth'}): iOS ignoriert
  // 'smooth', sobald "Bewegung reduzieren" aktiv ist -- dann wuerde das
  // Karussell nur hart umspringen. Snap wird waehrend der Fahrt kurz aus-
  // gehaengt, sonst zieht der Browser dagegen.
  function fhStopAnim(el) {
    if (!el.__fhTimer) return;
    clearInterval(el.__fhTimer);
    el.__fhTimer = null;
    el.style.scrollSnapType = el.__fhSnap || '';
  }

  function fhScroll(el, target, dur) {
    fhStopAnim(el);
    var start = el.scrollLeft;
    var delta = target - start;
    if (Math.abs(delta) < 2) return;
    var t0 = Date.now();
    el.__fhSnap = el.style.scrollSnapType;
    el.style.scrollSnapType = 'none';
    el.__fhTimer = setInterval(function () {
      var p = Math.min(1, (Date.now() - t0) / dur);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      el.scrollLeft = start + delta * e;
      if (p >= 1) fhStopAnim(el);
    }, 20);
  }

  function advance(el) {
    var slides = slidesOf(el);
    if (slides.length < 2) return;
    var max = el.scrollWidth - el.clientWidth - 2;
    if (el.scrollLeft >= max) { fhScroll(el, 0, 550); return; }
    var next = null;
    for (var i = 0; i < slides.length; i++) {
      var p = pos(el, slides[i]);
      if (p > el.scrollLeft + 8) { next = p; break; }
    }
    fhScroll(el, next === null ? 0 : Math.min(next, max), 450);
  }

  function buildDots(el) {
    var wrap = document.createElement('div');
    wrap.className = 'fh-dots';
    slidesOf(el).forEach(function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Karte ' + (i + 1));
      b.addEventListener('click', function () {
        el.__fhStop = true;
        fhScroll(el, pos(el, slide), 400);
      });
      wrap.appendChild(b);
    });
    el.parentNode.insertBefore(wrap, el.nextSibling);
    return wrap;
  }

  function syncDots(el, wrap) {
    var slides = slidesOf(el), idx = 0, best = Infinity;
    slides.forEach(function (s, i) {
      var d = Math.abs(pos(el, s) - el.scrollLeft);
      if (d < best) { best = d; idx = i; }
    });
    for (var i = 0; i < wrap.children.length; i++) {
      wrap.children[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
    }
  }

  function initScrollers() {
    document.querySelectorAll(SCROLLERS).forEach(function (el) {
      if (el.__fhInit || !isScrollable(el)) return;
      el.__fhInit = true;

      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
        el.addEventListener(ev, function () { el.__fhStop = true; fhStopAnim(el); }, { passive: true });
      });
      el.addEventListener('mouseenter', function () { el.__fhHover = true; });
      el.addEventListener('mouseleave', function () { el.__fhHover = false; });

      var own = el.classList.contains('fh-row') || el.classList.contains('fh-grid') ||
                /ai-steps-grid-/.test(el.className);
      var dots = own ? buildDots(el) : null;

      // "→ seitlich wischen"-Hinweis ersetzen wir durch die Punkte
      if (own && el.parentNode) {
        var hint = el.parentNode.querySelector('.fh-hint');
        if (hint) hint.style.display = 'none';
      }

      tracked.push({
        el: el,
        dots: dots,
        delay: el.classList.contains('product__media-list') ? 5500 : 4200,
        next: Date.now() + 2500
      });
    });
  }

  /* ---------------- 2. Judge.me-Karussells ------------------- */

  var jdgm = [];

  function initJudgeMe() {
    if (typeof window.jdgmNextCard !== 'function') return;
    document.querySelectorAll('.jdgm-widget[data-jdgm-block-id]').forEach(function (w) {
      if (w.__fhInit) return;
      if (!/carousel/.test(w.getAttribute('data-widget') || '')) return;
      if (w.querySelectorAll('.jdgm-carousel-item').length < 2) return;
      w.__fhInit = true;
      ['pointerdown', 'touchstart'].forEach(function (ev) {
        w.addEventListener(ev, function () { w.__fhStop = true; }, { passive: true });
      });
      w.addEventListener('mouseenter', function () { w.__fhHover = true; });
      w.addEventListener('mouseleave', function () { w.__fhHover = false; });
      jdgm.push({ w: w, id: w.getAttribute('data-jdgm-block-id'), next: Date.now() + 3000 });
    });
  }

  /* ---------------- 3. Logo-Laufband ------------------------- */

  function syncMarquee() {
    document.querySelectorAll('[class*="ai-membership-logos__grid-"]').forEach(function (grid) {
      var on = mqMobile.matches;
      var wrapped = grid.parentNode && grid.parentNode.classList.contains('fertia-marquee');
      if (on && !wrapped) {
        var wrap = document.createElement('div');
        wrap.className = 'fertia-marquee';
        grid.parentNode.insertBefore(wrap, grid);
        wrap.appendChild(grid);
        Array.prototype.slice.call(grid.children).forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-fh-clone', '1');
          grid.appendChild(clone);
        });
      } else if (!on && wrapped) {
        grid.querySelectorAll('[data-fh-clone]').forEach(function (c) { c.remove(); });
        var w = grid.parentNode;
        w.parentNode.insertBefore(grid, w);
        w.remove();
      }
    });
  }

  /* ---------------- 4. Mobile Sticky-Kaufleiste -------------- */

  var atcUpdate = null;

  function initMobileAtc() {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    if (document.getElementById('fertia-sticky-atc-m')) return;
    var submit = document.querySelector('.product-form__submit');
    if (!submit || submit.disabled) return;
    var form = submit.closest('form');
    if (!form) return;

    // Achtung: form.id liefert wegen des Varianten-Inputs name="id" das Element
    var formId = form.getAttribute('id');
    if (!formId) { formId = 'fertia-product-form-m'; form.setAttribute('id', formId); }

    var titleEl = document.querySelector('.product__title h1') || document.querySelector('h1');
    var priceEl = document.querySelector('.product__info-container .price-item--regular');

    var bar = document.createElement('div');
    bar.id = 'fertia-sticky-atc-m';
    bar.innerHTML = "<div class='fsa-m-info'><span class='fsa-m-title'></span>" +
                    "<span class='fsa-m-price'></span></div>" +
                    "<button type='submit'>In den Warenkorb</button>";
    bar.querySelector('.fsa-m-title').textContent = titleEl ? titleEl.textContent.trim() : '';
    bar.querySelector('.fsa-m-price').textContent = priceEl ? priceEl.textContent.trim() : '';
    bar.querySelector('button').setAttribute('form', formId);
    document.body.appendChild(bar);

    atcUpdate = function () {
      bar.classList.toggle('is-visible', submit.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', atcUpdate, { passive: true });
    window.addEventListener('resize', atcUpdate);
    atcUpdate();
  }

  // Die Desktop-Leiste (Inline-Skript in header-group.json) nimmt fuer den
  // Titel .product__title -- das ist der Wrapper und enthaelt den Titel doppelt.
  function fixDesktopAtcTitle() {
    var bar = document.getElementById('fertia-sticky-atc');
    var h1 = document.querySelector('.product__title h1');
    if (bar && h1) bar.querySelector('.fsa-title').textContent = h1.textContent.trim();
  }

  /* ---------------- 5. Mobile-Menue -------------------------- */

  // (a) Header fixieren, solange der Drawer offen ist (siehe CSS-Block 8)
  function watchDrawer() {
    var det = document.querySelector('header-drawer details');
    if (!det || det.__fhInit) return;
    det.__fhInit = true;
    var sync = function () {
      document.documentElement.classList.toggle('fertia-drawer-open',
        det.classList.contains('menu-opening') || det.hasAttribute('open'));
    };
    new MutationObserver(sync).observe(det, { attributes: true, attributeFilter: ['class', 'open'] });
    sync();
  }

  // (b) "Uebersicht" (= shop.fertia.de) ganz oben ins Shop-Untermenue.
  //     "Home" zeigt auf fertia.de, sonst kommt man nie zur Shop-Startseite zurueck.
  function addShopOverview() {
    var mk = function (cls) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '/';
      a.className = cls;
      a.setAttribute('data-fh-overview', '1');
      a.textContent = 'Übersicht';
      li.appendChild(a);
      return li;
    };

    var sub = document.querySelector('.header__inline-menu ul > li:first-child .header__submenu');
    if (sub && !sub.querySelector('[data-fh-overview]')) {
      var before = null;
      Array.prototype.some.call(sub.children, function (c) {
        if (c.querySelector('a')) { before = c; return true; }
        return false;
      });
      sub.insertBefore(mk('header__menu-item list-menu__item link link--text focus-inset'),
                       before || sub.firstChild);
      // Die Produktkarten daneben spannen in fertia-framer2.css fix 7 Zeilen.
      // Mit dem zusaetzlichen Link ist es eine mehr -- sonst reisst eine
      // Luecke zwischen Ueberschrift und Linkliste auf.
      var cards = sub.querySelector('.fertia-menu-cards');
      if (cards) {
        cards.style.setProperty('grid-row', '1 / span ' + (sub.children.length - 1), 'important');
      }
    }

    var items = document.querySelectorAll('.menu-drawer__menu > li');
    Array.prototype.forEach.call(items, function (li) {
      var sm = li.querySelector('summary');
      if (!sm || sm.textContent.trim() !== 'Shop') return;
      var ul = li.querySelector('.menu-drawer__submenu');
      if (!ul || ul.querySelector('[data-fh-overview]')) return;
      ul.insertBefore(mk('menu-drawer__menu-item list-menu__item link link--text focus-inset'),
                      ul.firstElementChild);
    });
  }

  /* ---------------- Taktgeber -------------------------------- */

  ready(function () {
    syncMarquee();
    initMobileAtc();
    fixDesktopAtcTitle();
    watchDrawer();
    addShopOverview();
    initScrollers(); initJudgeMe();

    var started = Date.now();
    var lastMq = mqMobile.matches;
    setInterval(function () {
      if (document.hidden) return;
      var now = Date.now();

      // Breakpoint-Wechsel (Drehen des Geraets) auch ohne resize-Event erkennen
      if (mqMobile.matches !== lastMq) {
        lastMq = mqMobile.matches;
        syncMarquee();
        initScrollers();
      }

      // Scroll-Events sind nicht ueberall verlaesslich -> Leiste hier mitpruefen
      if (atcUpdate) atcUpdate();

      // Nachzügler (Judge.me lädt asynchron, Sections können nachgeladen werden)
      if (now - started < 40000) { initScrollers(); initJudgeMe(); watchDrawer(); addShopOverview(); }

      tracked.forEach(function (t) {
        var live = isScrollable(t.el);
        if (t.dots) {
          t.dots.style.display = live ? '' : 'none';
          if (live) syncDots(t.el, t.dots);
        }
        if (!live || t.el.__fhStop || t.el.__fhHover || !inViewport(t.el)) {
          t.next = now + t.delay;
          return;
        }
        if (now >= t.next) { advance(t.el); t.next = now + t.delay; }
      });

      jdgm.forEach(function (j) {
        if (j.w.__fhStop || j.w.__fhHover || !inViewport(j.w)) { j.next = now + 5000; return; }
        if (now >= j.next) {
          try { window.jdgmNextCard(j.id); } catch (e) {}
          j.next = now + 5000;
        }
      });
    }, 500);

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { syncMarquee(); initScrollers(); }, 250);
    });
  });
})();
